var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeagueManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.607,
    height: 12.84,
    viewBox: "0 0 14.607 12.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56692",
    "data-name": "Group 56692",
    transform: "translate(-0.795 -25.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M15.4,88.627V98.07a.3.3,0,0,0-.021.053,1.272,1.272,0,0,1-1.3,1.087q-5.982,0-11.965,0a1.428,1.428,0,0,1-.59-.132A1.255,1.255,0,0,1,.795,97.84q0-4.528,0-9.056v-.118a.251.251,0,0,1,.064.113l1.446,4.335a1.3,1.3,0,0,0,1.337.962H5.959c0,.139,0,.262,0,.384a.432.432,0,0,0,.47.471q1.669,0,3.337,0a.432.432,0,0,0,.472-.469c0-.126,0-.253,0-.387h2.3a1.3,1.3,0,0,0,1.356-.974q.726-2.174,1.451-4.349c.015-.044.037-.085.056-.127",
    transform: "translate(0 -60.849)",
    fill: "#6f109e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M30.32,32.372c0-.151,0-.283,0-.416a.424.424,0,0,0-.444-.439q-1.7,0-3.395,0a.424.424,0,0,0-.439.443c0,.132,0,.264,0,.405-.049,0-.085.006-.122.006q-1.113,0-2.225,0a.439.439,0,0,1-.481-.34q-.788-2.356-1.571-4.714c-.007-.022-.012-.044-.021-.077h3.564c0-.139,0-.27,0-.4a1.276,1.276,0,0,1,.969-1.268,1.479,1.479,0,0,1,.381-.044q1.647,0,3.295,0a1.29,1.29,0,0,1,1.346,1.347c0,.114,0,.228,0,.356h3.572c-.021.067-.036.114-.052.16l-1.525,4.58a.476.476,0,0,1-.552.4h-2.3Zm-4.277-5.145H30.32c0-.109,0-.208,0-.308,0-.385-.151-.538-.531-.538H28.307c-.6,0-1.206,0-1.81,0a.424.424,0,0,0-.453.4c-.009.146,0,.293,0,.447",
    transform: "translate(-20.082)",
    fill: "#6f109e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3298",
    "data-name": "Rectangle 3298",
    width: 2.545,
    height: 0.844,
    transform: "translate(6.827 32.374)",
    fill: "#6f109e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeagueManagement);
export default __webpack_public_path__ + "static/media/league_management.2a841b71d9715be1d154736f3b8ddcd6.svg";
export { ForwardRef as ReactComponent };